const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '평가일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {'component': 'search-disaster-types', label: '재해형태', value: 'disaster', query: {'dty': 'disaster'}, options: {}},
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['재해형태', '평가일']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({key: 'body.inputB_4', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'body.inputB_4', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  재해형태
    if (search.disaster) {
      conditions.push({key: 'body.riskAppraisalList[%].input_3', operator: 'LIKE', value: `%${search.disaster}%`})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "회사명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "공정명",
        "key": "body.inputB_2"
      },
      {
        "name": "작업내용",
        "key": "body.작업내용"
      },
      {
        "name": "재해형태",
        "key": "body.riskAppraisalList[%].input_3"
      },
      {
        "name": "평가일",
        "key": "body.inputB_4"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      }
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 회사명
        case 1: return func.getContent(value).inputB_2; // 공정명
        case 2: return func.getContent(value).작업내용; // 작업내용
        case 3: return func.getContentRiskList(func.getContent(value).riskAppraisalList).replace(/직접입력_/g, '');// 재해형태
        case 4:
          return func.getContent(value).inputB_4; // 평가일
        case 5:
          return func.getContent(value).stdInfo.writer_name; // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
